module.exports = __webpack_public_path__ + "img/city-of-philadelphia.d1354314.png";